<template>
  <v-card elevation="0" class="all-trade-tab rounded-0">
    <v-tabs v-model="model" :background-color="$vuetify.theme.dark ? '#131c29' : 'white-lighten-2'">
      <v-tab :href="`#tab-1`">
        Partner List
      </v-tab>
      <v-tab :href="`#tab-2`"> 
        IB Request <strong>{{ totalPendingRequest || 0 }}</strong> 
      </v-tab>
      <v-tab :href="`#tab-3`"> 
        IB Rejected 
      </v-tab>
      
      <v-tabs-items v-model="model">
        <v-tab-item :value="`tab-1`">
          <v-card flat class="mt-8">
            <partner-list-tab v-if="visitedTabs.includes('tab-1')"></partner-list-tab>
          </v-card>
        </v-tab-item>
        
        <v-tab-item :value="`tab-2`">
          <v-card flat class="mt-8">
            <ib-request-tab v-if="visitedTabs.includes('tab-2')"></ib-request-tab>
          </v-card>
        </v-tab-item>
        
        <v-tab-item :value="`tab-3`">
          <v-card flat class="mt-8">
            <ib-rejected-tab v-if="visitedTabs.includes('tab-3')"></ib-rejected-tab>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { IBREQUEST__ACTIONS } from "@/store/action-types";
import IbRejectedTab from './IbRejectedTab.vue';
import IbRequestTab from './IbRequestTab.vue';
import PartnerListTab from './PartnerListTab.vue';

export default {
  components: {
    PartnerListTab,
    IbRequestTab,
    IbRejectedTab,
  },

  data() {
    return {
      model: "tab-1",
      visitedTabs: ["tab-1"], // Only first tab is visited initially
    };
  },

  computed: {
    ...mapState("ibrequest", ['allpendings', 'totalRequest', 'totalPendingRequest']),
  },

  watch: {
    model(newTab) {
      // Track which tabs have been visited
      if (!this.visitedTabs.includes(newTab)) {
        this.visitedTabs.push(newTab);
      }

      // Load IB request data only when tab-2 is visited
      if (newTab === 'tab-2' && !this.ibRequestDataLoaded) {
        this.loadIbRequestData();
      }
    }
  },

  methods: {
    ...mapActions("ibrequest", [
      IBREQUEST__ACTIONS.ALLPENDINGIBREQUEST,
    ]),

    async loadIbRequestData() {
      this.ibRequestDataLoaded = true;
      await this[IBREQUEST__ACTIONS.ALLPENDINGIBREQUEST]();
    }
  },

  created() {
    this.ibRequestDataLoaded = false;
    // Don't call API on mount - only Partner List loads by default
  },
};
</script>